import { useNavigate, useSearchParams } from "react-router-dom";
import { CreditNotesListPage as CreditNotesListPageView } from "@/components/CreditNotesListPage";

export function CreditNotesListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const customerId = searchParams.get("customerId") ?? undefined;

  return (
    <CreditNotesListPageView
      onInvoiceClick={(id) => navigate(`/invoices/${id}`)}
      onCreditNoteClick={(id) => navigate(`/credit-notes/${id}`)}
      defaultCustomerId={customerId}
      onCustomerFilterChange={(next) => {
        const params = new URLSearchParams();
        if (next) params.set("customerId", next);
        setSearchParams(params, { replace: true });
      }}
    />
  );
}
